import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-help-popover',
  templateUrl: './help-icon.component.html',
  styleUrls: ['./help-popover.component.scss']
})
export class HelpPopoverComponent implements OnInit {
  @Input() helpKey: string = '';
  @Input() translationObject: any = {};



  constructor(private popoverController: PopoverController) { }

  ngOnInit() { }

  getHelpText(): string {
    // First try the key directly (for keys like "UploadLogoInterview")
    if (this.translationObject[this.helpKey]) {
      return this.translationObject[this.helpKey];
    }

    // Then try with "Help" prefix and capitalized first letter (for keys like "HelpJobOfferLanguage")
    const helpKey = `Help${this.helpKey.charAt(0).toUpperCase() + this.helpKey.slice(1)}`;
    return this.translationObject[helpKey] || this.translationObject['HilfeNichtVerfügbar'] || 'Hilfe für diesen Bereich ist nicht verfügbar.';
  }

  hasDetailedHelp(): boolean {
    return false;
  }

  showDetailedHelp() {
    console.log('Show detailed help for:', this.helpKey);
  }

  closePopover() {
    this.popoverController.dismiss();
  }

  private getCurrentLanguage(): string {
    if (this.translationObject['Dashboard'] === 'Dashboard' &&
      this.translationObject['Hilfe'] === 'Help') {
      return 'en';
    }
    return 'de';
  }
}
